import React from 'react';
import { PlusIcon, UserIcon } from '@heroicons/react/24/outline';

const mockMembers = [
  { id: 1, name: 'John Smith', email: 'john@company.com', role: 'Owner', status: 'active' },
  { id: 2, name: 'Sarah Johnson', email: 'sarah@company.com', role: 'Admin', status: 'active' },
  { id: 3, name: 'Mike Brown', email: 'mike@company.com', role: 'Member', status: 'pending' },
];

const Team: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Team</h1>
          <p className="mt-1 text-gray-600">Manage your team members and permissions</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <PlusIcon className="h-5 w-5" />
          Invite Member
        </button>
      </div>

      {/* Members List */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-medium text-gray-900">Team Members ({mockMembers.length})</h2>
        </div>
        <div className="divide-y divide-gray-200">
          {mockMembers.map((member) => (
            <div key={member.id} className="px-6 py-4 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                  <UserIcon className="h-6 w-6 text-gray-400" />
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">{member.name}</p>
                  <p className="text-xs text-gray-500">{member.email}</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-sm text-gray-500">{member.role}</span>
                <span
                  className={`text-xs px-2 py-1 rounded-full ${
                    member.status === 'active'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-yellow-100 text-yellow-800'
                  }`}
                >
                  {member.status}
                </span>
                <button className="text-gray-400 hover:text-gray-600">•••</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
